import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MyReviews from '../Home/MyReviews';

const OrganizationMyReviews = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user);

  useEffect(() => {
    if (!userData) return;

    if (userData.part_of_organization !== true || !userData.organization_id) {
      navigate('/community');
      return;
    }
  }, [userData, navigate]);

  if (!userData || userData.part_of_organization !== true || !userData.organization_id) {
    return null;
  }

  return (
    <MyReviews
      organizationId={userData.organization_id}
      pageTitle="My Reviews"
    />
  );
};

export default OrganizationMyReviews;
